import React from "react";
import { motion } from "framer-motion";
import Logo from "../Logo";

export default function PricingHeader() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
      className="text-center mb-10"
    >
      <motion.div
        initial={{ opacity: 0, scale: 0.9, rotate: -3 }}
        animate={{ opacity: 1, scale: 1, rotate: 0 }}
        transition={{ duration: 0.7, type: "spring" }}
        className="mb-6 inline-block"
      >
        <div className="relative">
          <div
            aria-hidden
            className="absolute inset-0 rounded-full blur-2xl opacity-40 scale-150"
            style={{ background: "radial-gradient(circle, hsl(160 84% 39% / 0.35), transparent 70%)" }}
          />
          <div className="relative p-1">
            <Logo size={72} />
          </div>
        </div>
      </motion.div>

      <div className="flex items-baseline justify-center gap-1.5 font-mono text-xs tracking-[0.22em] uppercase mb-5">
        <span className="text-primary-fg font-semibold">Breakout</span>
        <span className="text-pos font-semibold">Scanner</span>
      </div>

      <div className="text-[10px] font-mono uppercase tracking-[0.25em] text-pos mb-3">
        /// Premium Membership
      </div>
      <h1 className="text-5xl font-medium tracking-tight text-primary-fg">
        Start Your Premium <span className="text-pos">Breakout Signals</span>
      </h1>
      <p className="text-secondary-fg mt-4 max-w-2xl mx-auto">
        High-probability multi-year breakout stocks with precise Buy, Target &amp; Stop-loss — confirmed by
        volume surge and AI fundamentals.
      </p>
    </motion.div>
  );
}
